<script setup lang="ts">
import { useUserStore } from '@core/stores/user'
import GamesTable from '@/views/pages/games/GamesTable.vue'

const { t } = useI18n()

definePage({
  meta: {
    action: 'read',
    subject: 'dashboard-expert',
  },
})

const userStore = useUserStore()
</script>

<template>
  <div>
    <VRow class="pt-6">
      <!-- 👉 Welcome -->
      <VCol
        cols="12"
        class="match-height"
      >
        <div class="pe-3">
          <h5 class="text-h5 mb-2">
            {{ t('dashboards.player.summary.welcome') }}, <span class="text-h4"> {{ userStore.fullName.split(' ')[0] }} 👋🏻 </span>
          </h5>
        </div>
      </VCol>
    </VRow>

    <VRow class="match-height">
      <!-- 👉 Topics you are interested in -->

      <VCol>
        <GamesTable
          :show-add-button="false"
          :for-participant="false"
          for-expert
          :player-id="null"
        />
      </VCol>
    </VRow>
  </div>
</template>

<style lang="scss">
@use "@core-scss/template/libs/apex-chart.scss";
</style>
